var _defs, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew261({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:0.41px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9.75,
    cy: 8,
    r: 5.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 1,
    y1: 3.29,
    x2: 1,
    y2: 12.71
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.51,
    y1: 8,
    x2: 1,
    y2: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew261);
export default __webpack_public_path__ + "static/media/Symbolpack_New_261.9eac4bf3ca2dba787f2dbb51c543fc4c.svg";
export { ForwardRef as ReactComponent };